/*
  Ivy Pillow — "Vaak samen gekocht": elke productoptie heeft een eigen
  keuzelijst. Bij een wijziging zoeken we de bijbehorende variant op, zetten
  we het verborgen id-veld, tonen we de juiste prijs en blokkeren we de knop
  wanneer die combinatie niet leverbaar is.
*/
(() => {
  function init(scope) {
    const bereik = scope && scope.querySelectorAll ? scope : document;

    bereik.querySelectorAll('[data-ivy-upsell]').forEach((blok) => {
      if (blok.dataset.ivyInit === 'true') return;
      blok.dataset.ivyInit = 'true';

      const data = blok.querySelector('[data-upsell-varianten]');
      const idVeld = blok.querySelector('[data-upsell-variant-id]');
      const prijs = blok.querySelector('[data-upsell-prijs]');
      const knop = blok.querySelector('[data-upsell-knop]');
      const selects = Array.from(blok.querySelectorAll('[data-upsell-optie]'));
      if (!data || !idVeld || !selects.length) return;

      let varianten = [];
      try {
        varianten = JSON.parse(data.textContent) || [];
      } catch (e) {
        return;
      }

      const geld = (cent) => {
        try {
          return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(cent / 100);
        } catch (e) {
          return '€ ' + (cent / 100).toFixed(2).replace('.', ',');
        }
      };

      const werkBij = () => {
        const keuze = selects.map((s) => s.value);
        const variant = varianten.find((v) =>
          keuze.every((waarde, i) => (v.options || [])[i] === waarde)
        );

        if (!variant) {
          knop?.setAttribute('disabled', 'disabled');
          return;
        }

        idVeld.value = variant.id;
        if (prijs) prijs.textContent = geld(variant.price);

        if (variant.available) knop?.removeAttribute('disabled');
        else knop?.setAttribute('disabled', 'disabled');
      };

      selects.forEach((s) => s.addEventListener('change', werkBij));
      werkBij();
    });
  }

  document.addEventListener('DOMContentLoaded', () => init(document));
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => init(e.target));
  }
})();
